import i18next from 'i18next';

i18next.addResources('en', 'AdelphiMainMenu', {
  title: 'Main Menu',
  productionMenu: 'Production Menu',
  products: 'Products',
  checklistsMenu: 'Checklists Menu'
});
